import { EyeRefreshIcon } from './EyeRefreshIcon';

/**
 * author: nlsve
 * id 2CC60524-7C0C-4AE3-A996-E24066985409
 * name eye-refresh
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eye-refresh.svg
 * tags
 */
export const ViewRefreshIcon = EyeRefreshIcon;
export default ViewRefreshIcon